Quill.register('modules/maxlength', function(quill, options) {

    quill.on('text-change', function(e) {
            let size = quill.getText();
            if (size.length >= options.value)
            {
                quill.history.undo();
                // on peut gérer le cas de copie/past massif qui ne contiennent que des attributes, insert
                // on supprimerait alors autant de caractères des inserts que nécessaire
                // - pour les pastes à une position donnée on a retain :
                quill.emitter.emit('max-length-reached');
            }
    });

});